import { Moment } from 'moment';
import { DayOfWeek } from '@/shared/models/common';

export default class BusinessHours {
  daysOfWeek: Array<DayOfWeek> = [];
  start!: Moment;
  end!: Moment;
  laborMinutes!: number;
  plannedMinutes!: number;

  get availableMinutes(): number {
    return this.laborMinutes - this.plannedMinutes;
  }
}
